import Foods from "../../data/Foods";
import Dropdown from "../../gui/Dropdown/Dropdown";
import { UpdateEvent } from "../../gui/GUIEvents";
import Tooltip from "../../gui/Overlay/Tooltip";

export interface IFoodListProps {
    index:number
    foodIds:number[]
    foodId:number
    error?:string
    onUpdate:(e:UpdateEvent<number>) => void
}
export default function FoodList(props:IFoodListProps){
    return <Tooltip tooltip={Foods.i.name(props.foodId)} className="food">
        <Dropdown anchorProps={{width:"match"}} canClear={false} options={Foods.i.options} placeholder="Ingredient" defaultValue={props.foodId} onUpdate={props.onUpdate}/>
    </Tooltip>
}